<div class="additional-container" [formGroup]="formGroup">
  <p class="note">If the answer to any of the above questions is in the affirmative, please provide more information
    below and supporting documents, if any.
  </p>
  <div class="col-md-10">
    <mat-label class="field-label">Leave a comment (Optional)</mat-label>
    <mat-form-field class="example-full-width">
      <textarea class="text-field" matInput formControlName="details" placeholder="Enter text..."></textarea>
    </mat-form-field>
  </div>
  </div>
  @if(readonly() === false){
  <!-- Form Actions -->
  <div class="form-actions">

    <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

      <span>Save & Continue</span>
      <mat-icon>arrow_forward</mat-icon>

    </button>
  </div>
}